import { Injectable } from '@angular/core';

import { acquireStaffToken, beginStaffSignIn, completeStaffSignIn, endStaffSession, isStaffAuthConfigured } from './msal-client';

/** Injectable face over the Entra client. */
@Injectable({ providedIn: 'root' })
export class MsalAuthService {
    isConfigured(): boolean {
        return isStaffAuthConfigured();
    }

    signIn(): Promise<void> {
        return beginStaffSignIn();
    }

    completeSignIn(): Promise<string | null> {
        return completeStaffSignIn();
    }

    acquireToken(directoryObjectId?: string): Promise<string> {
        return acquireStaffToken(directoryObjectId);
    }

    signOut(): Promise<void> {
        return endStaffSession();
    }
}
